import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import { queryClient } from './lib/queryClient'
import { SiteDataProvider } from './lib/SiteDataProvider'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <SiteDataProvider>
          <App />
        </SiteDataProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
